<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form label-width="100px" :inline="true" :model="filters">
        <el-form-item label="Số Đơn Hàng">
          <el-input
            v-model="filters.sdk_orderno"
            placeholder="Số Đơn Hàng"
          ></el-input>
        </el-form-item>
        <el-form-item label="Trạng Thái">
          <el-select v-model="filters.orderStatus" placeholder="Trạng Thái">
            <el-option
              v-for="item in pay_status_list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Tên Game">
          <el-select v-model="filters.merchant_id" placeholder="Tên Game">
            <el-option
              v-for="item in game_list"
              :key="item.merchant_id"
              :label="item.username"
              :value="item.merchant_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Date">
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          />
        </el-form-item>
        <el-form-item label="UID">
          <el-input v-model="filters.user_id" placeholder="UID"></el-input>
        </el-form-item>

        <br />
        <div style="margin-left: 100px">
          <el-form-item>
            <el-button type="primary" @click="searchUsers">Tìm</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="reset">Đặt Lại</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      id="mainTable"
      :data="order_info"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="order_no" label="Số Đơn Hàng"> </el-table-column>
      <el-table-column prop="user_id" label="UID"> </el-table-column>
      <el-table-column prop="pay_status" label="Trạng Thái">
        <template #default="scope">
          <span v-if="scope.row.pay_status == 0">Chờ xử lý</span>
          <span v-else-if="scope.row.pay_status == 1">Hoàn thành</span>
          <span v-else>{{ scope.row.pay_status }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="merchant_id" label="Tên Game"> </el-table-column>
      <el-table-column prop="amount" label="Số tiền thanh toán">
      </el-table-column>
      <el-table-column prop="mer_order_no" label="Mã kênh"> </el-table-column>
      <el-table-column prop="created_at" label="Thời gian tạo">
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="Number(currentPage)"
        @current-change="handleCurrentChange"
      />
    </el-col>
  </section>
</template>

<script>
import { orderListApi, gameListApi } from "@/utils/api";

export default {
  data() {
    return {
      filters: {
        sdk_orderno: "",
        orderStatus: "",
        merchant_id: "",
        user_id: "",
      },
      date: null,
      order_info: [],
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pageSize: 20, // 分页大小
      listLoading: false,
      sels: [], //列表选中列
      token: localStorage.getItem("token"),
      pay_status_list: [
        {
          value: "",
          label: "Toàn bộ",
        },
        {
          value: 0,
          label: "Chờ xử lý",
        },
        {
          value: 1,
          label: "Hoàn thành",
        },
      ],
      game_list: [],
    };
  },
  mounted() {
    this.getGameList();
    this.getUsers();
  },
  methods: {
    searchUsers() {
      this.currentPage = 1;
      this.getUsers();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUsers();
    },
    //获取游戏列表
    getGameList() {
      gameListApi().then((res) => {
        if (res.code == 200) {
          this.game_list = res.data;
        }
      });
    },
    //获取用户列表
    getUsers() {
      let params = {
        token: this.token,
        page: this.currentPage,
        sdk_orderno: this.filters.sdk_orderno,
        orderStatus: this.filters.orderStatus,
        merchant_id: this.filters.merchant_id,
        user_id: this.filters.user_id,
        startTime: "",
        endTime: "",
      };
      // 提取并格式化日期范围（如果有选择）
      if (this.date && this.date.length === 2) {
        const [startDate, endDate] = this.date; // 解构数组：开始时间、结束时间
        params.startTime = this.formatDate(startDate); // 格式化开始时间
        params.endTime = this.formatDate(endDate); // 格式化结束时间
      }
      this.listLoading = true;
      orderListApi(params).then((res) => {
        this.total = res.total;
        this.currentPage = res.page;
        this.order_info = res.data;
        this.listLoading = false;
      });
    },
    reset() {
      this.filters = {
        sdk_orderno: "",
        orderStatus: "",
        merchant_id: "",
        user_id: "",
      };
      this.date = null;
      this.handleCurrentChange(1);
    },
    formatDate(date) {
      if (!date) return "";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需+1
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped></style>
